import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import LoginOutlinedSvg from "@ant-design/icons-svg/es/asn/LoginOutlined";
import AntdIcon from "../components/AntdIcon";
var LoginOutlined = function LoginOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: LoginOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  LoginOutlined.displayName = 'LoginOutlined';
}
export default /*#__PURE__*/React.forwardRef(LoginOutlined);